module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"Set up your stages in Pipeline","description":"Before you can create pipeline automations, you’ll need to set up Pipeline and add your stages.","action":"Set up Pipeline"}}')
  delete Component.options._Ctor
}
